/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_TitleInputs */



/**
* | output |
* | --- |
* | "Chainspect \| Web3’s Top Blockchain Fundamentals Tracker" |
*
* @param {Seo_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const seo_title = /** @type {((inputs?: Seo_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Chainspect | Web3’s Top Blockchain Fundamentals Tracker")
});